import React, {useEffect} from "react";
import {ch, UserInteractionDataStorage} from "@reapptor-apps/reapptor-react-common";
import {AddressHelper, Layout} from "@reapptor-apps/reapptor-react-components";
import TemplateAppConstants from "@/helpers/TemplateAppConstants";
import FenixAppController from "@/pages/FenixAppController";
import {Footer} from "@/components/Footer/Footer";

import appLogo from "./app-logo-white.png";
import companyLogo from "./company-logo.png";
import {TopNavSearch} from "@/components/TopNavSearch/TopNavSearch";
import MetaTags from "@/components/MetaTags/MetaTags";
import {HelmetProvider} from "react-helmet-async";

declare global {
  interface Window { dataLayer: any[]; }
}

const App = () => {

    useEffect(() => {
      window.dataLayer = window.dataLayer || [];
      const host = window.location.host ?? "";
      const isDevelopmentMode = host.startsWith("localhost");
      if(isDevelopmentMode) {
        console.info("Gtag in development mode");
      } else {
        console.info("Gtag ready to send analytics");
      }
      function gtag(arg0: string, arg1?: any, arg3?: any) {
        if (isDevelopmentMode) {
          return;
        }
        window.dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("consent", "default", {
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        analytics_storage: "denied"
      });
      gtag("config", 'G-ZK31GPCBDN');
    }, [])

    return (
        <>
            <HelmetProvider>
                <MetaTags />
                <Layout
                    useRouting
                    //languagesNoFlags
                    topNavLogo={appLogo}
                    searchRender={<TopNavSearch/>}
                    topNavLogoText={TemplateAppConstants.applicationName}
                    //leftNav={() => FenixAppController.getLeftNav()}
                    footerName={TemplateAppConstants.companyName}
                    languages={() => FenixAppController.languages()}
                    footerRender={() => <Footer phoneNumber={FenixAppController.fenixSupportPhone}/>}
                    footerLogo={companyLogo}
                    onChangeLanguage={(sender, language) => FenixAppController.changeLanguage(language)}
                    onLogoClick={() => FenixAppController.onLogoClickAsync()}
                />
            </HelmetProvider>

        </>
    );
};

//Register initialize events
ch.registerInitializeCallback(async () => await FenixAppController.initializeAsync());
//Register authorize events
ch.registerAuthorizeCallback(async () => await UserInteractionDataStorage.onAuthorize());
ch.registerAuthorizeCallback(async () => await FenixAppController.authorizeAsync());

export default App;
